
import {loadLanguage} from 'common/js/cache'

const state = {
	windowW:320,
	productsH:1,
	product:{},
	prodctList:[],
	lang:loadLanguage(),
	language:{
		products_btn_en:"VIEW",
		products_btn_cn:"查看",
		download_btn_en:"DOWNLOAD",
		download_btn_cn:"下载",
		pd_li_home_en:"Home",
		pd_li_products_en:"Products",
		pd_li_product_details_en:"Product Details",
		pd_li_home_cn:"主页",
		pd_li_products_cn:"产品",
		pd_li_product_details_cn:"产品详情",
		contact_name_en:"NAME",
		contact_name_cn:"姓名",
		contact_email_en:"Your email address or phone number",
		contact_email_cn:"你的联系方式（邮箱地址或电话号码）",
		contact_title_en:"TITLE",
		contact_title_cn:"标题",
		contact_btn_en:"SEND",
		contact_btn_cn:"发送",
		contact_message_en:"MESSAGE",
		contact_message_cn:"信息",
		contact_type_en:"Type",
		contact_type_cn:"类型",
		contact_company_en:"Company",
		contact_company_cn:"公司",
		error_company_en:'Company can not be empty',
		error_company_cn:'公司不能为空',
		error_name_en:'Name can not be empty',
		error_name_cn:'姓名不能为空',
		error_title_en:'Title can not be empty',
		error_title_cn:'标题不能为空',
		error_message_en:'Message can not be empty',
		error_message_cn:'信息不能为空',
		error_email_en:'Email address or phone number can not be empty',
		error_email_cn:'联系方式不能为空',
		back_en:"back",
		back_cn:"返回",
		no_product_details_tip_en:"Sorry, the product information has not been uploaded.",
		no_product_details_tip_cn:"抱歉,还没有上传产品信息",
		wecode_text_cn:"79￥全网通4G模组重磅来袭",
		wecode_text_en:"79¥ Full Netcom 4G module hits heavy"
	}
}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js